import { datadogRum } from '@datadog/browser-rum';

import { User } from '@/lib/apollo/types/gen/graphql';

const isEnabled = import.meta.env.VITE_DATADOG_ENABLE === '1';

export const initDatadog = (): void => {
  if (!isEnabled) {
    return;
  }

  datadogRum.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    site: 'datadoghq.com',
    service: 'frontend_v2',
    env: import.meta.env.MODE,
    version: process.env.BUILD_VERSION, // vite.config.mts でセット
    sessionSampleRate: Number(import.meta.env.VITE_DATADOG_SAMPLE_RATE),
    sessionReplaySampleRate: Number(
      import.meta.env.VITE_DATADOG_REPLAY_SAMPLE_RATE,
    ),
    trackUserInteractions: true,
    // RUM 5以降は既定でリソース・long taskを全セッションで収集する（4系は未指定だとリプレイ対象のみ）。
    // イベント量（課金）を増やさないため収集しない。トレースヘッダは4系の既定どおり全リクエストへ付与する
    trackResources: false,
    trackLongTasks: false,
    traceContextInjection: 'all',
    // RUM 5以降の既定（true）では、API宛ての全リクエストへ session.id・user.id が baggage ヘッダで付くため付けない（4系の挙動）
    propagateTraceBaggage: false,
    silentMultipleInit: true,
    allowedTracingUrls: Array.from(
      new Set([
        import.meta.env.VITE_API_BASE_URL,
        import.meta.env.VITE_GQL_BASE_URL,
      ]),
    ),
  });
  datadogRum.startSessionReplayRecording();
};

export const setDatadogUser = (userId?: User['userId']): void => {
  if (!isEnabled) {
    return;
  }

  if (userId) {
    datadogRum.setUser({
      id: userId,
    });
  } else {
    datadogRum.clearUser();
  }
};
